import React from "react";
import Icon from "@ant-design/icons";

const SpeakerWaveFilledSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    fill="none"
    viewBox="0 0 25 24"
  >
    <path
      fill="#6938EF"
      d="M11.745 18.46c.566 0 .98-.42.98-.978V5.978c0-.565-.415-1.017-.995-1.017-.384 0-.655.166-1.07.557L7.513 8.464a.239.239 0 01-.174.068H5.206c-1.115 0-1.717.618-1.717 1.785v2.803c0 1.167.602 1.785 1.717 1.785h2.132c.068 0 .12.023.174.068l3.149 2.968c.376.362.693.52 1.085.52zm6.698-1.378a.727.727 0 001.01-.218c.979-1.386 1.551-3.247 1.551-5.16 0-1.914-.565-3.782-1.552-5.161-.24-.354-.663-.437-1.01-.219-.36.227-.414.679-.142 1.078.798 1.175 1.258 2.704 1.258 4.301 0 1.59-.467 3.12-1.258 4.302-.264.4-.219.844.143 1.077zm-3.029-2.019a.708.708 0 00.98-.196c.61-.813.971-1.966.971-3.164 0-1.197-.361-2.343-.971-3.164a.7.7 0 00-.98-.188c-.369.241-.444.686-.143 1.122.414.596.648 1.394.648 2.23 0 .837-.241 1.628-.648 2.23-.294.437-.226.882.143 1.13z"
    ></path>
  </svg>
);

const SpeakerWaveFilledIcon = (props) => (
  <Icon component={SpeakerWaveFilledSvg} {...props} />
);

export { SpeakerWaveFilledIcon };
